$(document).ready(function () {
    $('#forgotPassword').validate({
        rules: {
            email: {
                required: true,
                email: true,
                validate_email: true,
            },
        },
        messages: {
            email: {
                required: "Please enter the Email",
                validate_email: "Please enter a valid Email",
                email: "Please enter a valid Email"
            },
        },
        errorElement: 'div',
        errorClass: 'validate-message',
        errorPlacement: function (error, element) {
            errorMsgPlacement(error, element);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass(errorClass).removeClass(validClass);
            $(element).closest('.form-group').addClass('invalid');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass(errorClass).addClass(validClass);
            $(element).closest('.form-group').removeClass('invalid');
        },
        submitHandler: function (form) {
            $.ajax({
                url: appConfig.api_url + 'password/forgot',
                type: 'POST',
                dataType: 'json',
                data: $(form).serialize(),
                beforeSend: function () {
                    showLoader();
                    $('.save_forgot').attr('disabled', true);
                },
                success: function (data) {
                    hideLoader();
                    $(form)[0].reset();
                    successToaster(data.meta.message);
                    setTimeout(function(){
                        window.location.href = appConfig.url + 'login';
                    }, 2000);
                },
                error: function (xhr) {
                    hideLoader();
                    $('.save_forgot').removeAttr('disabled');
                    showErrorAlertFromException(xhr);
                }
            });
            return false;
        }
    });
});